import * as THREE from 'three'

export class ThreeMaterials {
  public createArcheologyMaterial(): THREE.ShaderMaterial {
    return new THREE.ShaderMaterial({
      vertexShader: `
      varying float vAltitude;
      void main() {
        vAltitude = position.y;
        gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
      }
    `,
      fragmentShader: `
        varying float vAltitude;
        void main() {
          gl_FragColor = 0.5*( vec4((vAltitude + 10.0) * 0.10));
        }
        `,
    })
  }

  public createArcheologyBlendMaterial(texture: THREE.Texture): THREE.ShaderMaterial {
    return new THREE.ShaderMaterial({
      blending: THREE.CustomBlending,
      depthTest: false,
      depthWrite: false,
      uniforms: {
        mixfactor: { value: 0.8 },
        tex1: { value: texture }, // this.fboFg_.texture
      },
      vertexShader: `
      varying vec2 vUv;
      void main() {
        vUv = uv;
        gl_Position = vec4( position, 1.0 );
      }
    `,
      fragmentShader: `
    	uniform float mixfactor;
        uniform sampler2D tex1;
        varying vec2 vUv;
        void main() {
          vec4 texel = texture2D(tex1, vUv);
          texel += vec4(0.2);
          texel.a = mixfactor;
          gl_FragColor = linearToOutputTexel(texel);
        }
        `,
    })
  }

  // Material for texture transition
  public createTextureTransitionMaterial(textureF: THREE.Texture, textureB: THREE.Texture): THREE.ShaderMaterial {
    return new THREE.ShaderMaterial({
      depthTest: false,
      depthWrite: false,
      premultipliedAlpha: true,
      uniforms: {
        mixfactor: { value: 0.0 },
        tex0: { value: textureB }, // f
        tex1: { value: textureF }, // b
      },
      vertexShader: `
      varying vec2 vUv;
      void main() {
        vUv = uv;
        gl_Position = vec4( position, 1.0 );
      }
    `,
      fragmentShader: `
    	uniform float mixfactor;
        uniform sampler2D tex0;
        uniform sampler2D tex1;
        varying vec2 vUv;
        void main() {
          vec4 texel = mix(texture2D(tex0, vUv), texture2D(tex1, vUv), mixfactor);
          gl_FragColor = linearToOutputTexel( texel);
        }
        `,
    })
  }
}
